<template>
	<div>
		<div
			:style="{
				backgroundImage: `url(${require(`../assets/levels/${level}/bg.png`)}`,
			}"
			class="canvas-container base-text"
		>
			<div v-if="score.current" class="active-score">{{ score.current }}</div>

			<div class="menu" v-if="isMenuActive">
				<div class="menu__game-over">
					<div class="menu__game-over-bar"></div>
					<div class="menu__game-over-bar"></div>
					<div class="menu__game-over-bar"></div>
					<div class="menu__game-over-bar"></div>
					<div class="menu__game-over-bar"></div>
				</div>
				<div class="menu__container fade-in">
					<div class="menu__title">Game Over</div>
					<div class="menu_score">
						<div class="menu__score-row">
							<div class="menu__score-label">Score</div>
							<div class="menu__score-value">{{ score.current }}</div>
						</div>
						<div class="menu__score-row">
							<div class="menu__score-label">Best</div>
							<div class="menu__score-value">{{ score.best }}</div>
						</div>
					</div>
					<div class="menu__promo">
						Levels
						<div class="levels">
							<div
								@click="openView(level, 'game')"
								class="levels__container base-text"
								:class="{ 'level-disabled': levels[index].unlockedAt > best }"
								v-for="(level, index) in levels.length"
								:key="index"
							>
								<div
									class="level center-box"
									:style="{
										backgroundImage: `url(${require(`../assets/levels/${level}/thumbnail.png`)}`,
									}"
								></div>

								Stage {{ level }}
							</div>
						</div>
					</div>
					<div class="menu__cta">
						<div @click="toScorePage" class="button button-outline no-select">
							JOIN THE LEADERBOARD
						</div>
						<div class="menu__or">OR</div>
						<div @click="closeMenu" class="button button-filled no-select">
							Restart
						</div>
					</div>
				</div>
			</div>

			<div class="menu bg" v-if="isAddingScore">
				<div class="menu__container">
					<div class="menu__title">
						You Scored <br />
						{{ score.current }}
					</div>

					<div class="menu__promo">
						<div class="menu__promo-image">
							<img src="../assets/logo.png" />
						</div>
					</div>
					<div class="menu__cta">
						<label for="">
							Name:
							<input v-model="user.name" type="text" />
						</label>
						<label for="">
							Email:
							<input v-model="user.email" type="text" />
						</label>

						<div
							@click="addScore"
							class="button button-filled"
							:class="{ 'button-saving': isScoreSaving }"
						>
							Add Score
						</div>
					</div>
				</div>
			</div>
      <div class="menu bg" v-if="!isGameLoaded">
				<div class="menu__container">
					<div class="menu__title mb-1">Loading...</div>
          <loading class="mt-1" />
        </div>
      </div>
			<div id="game-container" width="320px" height="480px">
				<canvas
					class="game no-select"
					id="pipes"
					width="320px"
					height="480px"
				></canvas>
				<canvas
					class="game no-select"
					id="ground"
					width="320px"
					height="480px"
				></canvas>
				<canvas class="game" id="sack" width="320px" height="480px"></canvas>
			</div>
		</div>
	</div>
</template>

<script>
	import Loading from '@/components/svg/Loading';
	import scoresService from '@/services/score';

	import fg from '../sprites/fg.js';
	import getReady from '../sprites/getReady.js';
	import score from '../utils/score.js';
	import jump from '../utils/jump.js';
	import Stats from 'stats.js';
	const stats = new Stats();
	import clonedeep from 'lodash.clonedeep';
	import { mapGetters } from 'vuex';

	export default {
		props: ['level', 'levels', 'best'],
		watch: {
			level(value) {
				this.spriteImage = require(`../assets/levels/${value}/sprite.png`);
				this.needsUpdate = true;
			}
		},
		data() {
			return {
				touchCount: 0,
				originalLevel: 1,
				debugMode: false,
				isMenuActive: false,
				isAddingScore: false,
				isScoreSaving: false,
				needsUpdate: false,
				gameTime: [],
				sprite: '',
				spriteImage: require(`../assets/levels/${this.level}/sprite.png`),
				user: {
					name: '',
					email: '',
				},
				score: {
					current: 0,
					best: 0,
				},
				state: {
					current: 0,
					getReady: 0,
					game: 1,
					over: 2,
				},
				speed: {
					pipeRate: 4,
					pipeFrequency: 60,
					gravity: 0.8,
					jump: 8,
					flapRest: 5,
					flapActive: 3,
				},
				game: {},
			};
		},
		created() {
			this.needsUpdate = true;
			if (this.$route.query.debug) {
				this.debugMode = true;
			}

			this.originalLevel = clonedeep(this.level);
		},
    components: {
      Loading
    },
		computed: {
			...mapGetters(['currentLevel', 'frameRate', 'physics']),
			isGameLoaded() {
				return this.frameRate.average;
			}
		},
		methods: {
			closeMenu() {
				this.fly(this.game);
			},
			fly(reset) {
				if (this.originalLevel !== this.level) {
					this.sprite.src = this.spriteImage;
					this.originalLevel = clonedeep(this.level);
				}

				jump.action(this.game, reset);
			},
			toScorePage() {
				this.isAddingScore = true;
			},
			openView(level, view) {
				this.$parent.viewMode = view;
				this.$parent.level = level;
				this.fly(this.game);
			},
			async addScore() {
				this.isScoreSaving = true;
				let response;

				if (!this.user.name.length || !this.user.email.length) return;

				try {
					let score = {
						count: this.score.current,
						score: {
							current: this.score.current,
							best: this.score.best,
							level: this.level
						},
						level: this.level,
						user: this.user
					};
					if (this.gameTime.length >= 2) {
						score.t = `v2-${this.gameTime[0].timestamp}-${this.gameTime[this.gameTime.length - 1].timestamp}-${this.gameTime[this.gameTime.length - 1].timestamp - this.gameTime[0].timestamp}`;
					}
					response = await scoresService.v2.create(score);
					if (response && response.token) {
						window.hj('identify', response.token, score);
					}
				} catch (error) {
					alert('trouble saving score');
				} finally {

					this.isAddingScore = false;
					this.openView(self.level, 'leaderboard');
					this.isScoreSaving = false;
				}
			},
			resizeCanvas() {
				const container = document.getElementById('game-container');

				let scaleX = window.innerWidth / 320;
				let scaleY = window.innerHeight / 480;

				if (window.innerWidth <= 320) {
					container.style.transform = `scale(${(scaleX, scaleY)})`;
				} else {
					container.style.transform = `scale(${scaleY})`;
				}
			},
		},
		mounted() {
			let self = this;

			if (self.debugMode) {
				stats.showPanel(0);
				document.body.appendChild(stats.dom);
			}

			// SELECT canvas
			self.game.canvas = {
				pipes: document.getElementById('pipes'),
				ground: document.getElementById('ground'),
				sack: document.getElementById('sack'),
			};
			self.game.ctx = {
				pipes: this.game.canvas.pipes.getContext('2d', { alpha: true }),
				ground: this.game.canvas.ground.getContext('2d', { alpha: true }),
				sack: this.game.canvas.sack.getContext('2d', { alpha: true }),
			};

			let frames = 0;
			const DEGREE = Math.PI / 180;

			self.sprite = new Image();
			self.sprite.src = self.spriteImage;

			const sack = {
				animation: [
					{ sX: 420, sY: 166 },
					{ sX: 420, sY: 200 },
					{ sX: 420, sY: 166 },
					{ sX: 420, sY: 232 },
				],
				deathAnimation: [
					{ sX: 420, sY: 300 },
					{ sX: 420, sY: 265 },
					{ sX: 420, sY: 335 },
					{ sX: 420, sY: 265 },
				],
				x: 70,
				y: 150,
				w: 70,
				h: 25,

				radius: 8,

				frame: 0,

				speed: 0,
				rotation: 0,

				draw: function(game) {
					let sack;
					if (this.speed >= game.physics.jump + 4) {
						sack = this.deathAnimation[this.frame];
					} else {
						sack = this.animation[this.frame];
					}

					game.ctx.sack.save();
					game.ctx.sack.translate(this.x, this.y);
					game.ctx.sack.rotate(this.rotation);
					game.ctx.sack.drawImage(
						game.sprite,
						sack.sX,
						sack.sY,
						this.w,
						this.h,
						-this.w / 2,
						-this.h / 2,
						this.w,
						this.h
					);

					game.ctx.sack.restore();
				},

				flap: function(game) {
					this.speed = -game.physics.jump;
				},

				update: function(game) {
					// IF THE GAME game.state IS GET READY game.state, THE sack MUST FLAP SLOWLY
					this.period =
						game.state.current == game.state.getReady
							? game.physics.flapRest
							: game.physics.flapActive;
					// WE INCREMENT THE FRAME BY 1, EACH PERIOD
					this.frame += game.frames % this.period == 0 ? 1 : 0;
					// FRAME GOES FROM 0 To 4, THEN AGAIN TO 0
					this.frame = this.frame % this.animation.length;

					if (game.state.current == game.state.getReady) {
						this.y = 150; // RESET POSITION OF THE sack AFTER GAME OVER
						this.rotation = 0 * game.degree;
					} else {
						this.speed += game.physics.gravity * 1.05;
						this.y += this.speed;

						if (this.y + this.h / 2 >= game.canvas.sack.height - game.fg.h) {
							this.y = game.canvas.sack.height - game.fg.h - this.h / 2;
							if (game.state.current == game.state.game) {
								game.state.current = game.state.over;
							}
						}

						// IF THE SPEED IS GREATER THAN THE JUMP MEANS THE sack IS FALLING DOWN
						if (this.speed >= game.physics.jump + 4) {
							this.rotation = 70 * game.degree;
							this.frame = 0;
						} else {
							this.rotation = 0 * game.degree;
						}
					}
				},
				speedReset: function() {
					this.speed = 0;
				},
			};

			// PIPES
			const pipes = {
				position: [],

				top: {
					sX: 553,
					sY: 0,
				},
				bottom: {
					sX: 502,
					sY: 0,
				},

				w: 53,
				h: 400,
				gap: 80,
				maxYPos: -150,
				dx: 4,

				draw: function(game) {
					for (let i = 0; i < this.position.length; i++) {
						let p = this.position[i];

						let topYPos = p.y;
						let bottomYPos = p.y + this.h + this.gap;

						// top pipe
						game.ctx.pipes.drawImage(
							game.sprite,
							this.top.sX,
							this.top.sY,
							this.w,
							this.h,
							p.x,
							topYPos,
							this.w,
							this.h
						);

						// bottom pipe
						game.ctx.pipes.drawImage(
							game.sprite,
							this.bottom.sX,
							this.bottom.sY,
							this.w,
							this.h,
							p.x,
							bottomYPos,
							this.w,
							this.h
						);
					}
				},

				update: function(game) {
					if (game.state.current !== game.state.game) return;

					if (game.frames % game.physics.pipeFrequency == 0) {
						this.position.push({
							x: game.canvas.pipes.width,
							y: this.maxYPos * (Math.random() + 1),
						});
					}
					for (let i = 0; i < this.position.length; i++) {
						let p = this.position[i];

						let bottomPipeYPos = p.y + this.h + this.gap;

						// COLLISION DETECTION
						// TOP PIPE

						if (
							game.sack.x + game.sack.radius > p.x &&
							game.sack.x - game.sack.radius < p.x + this.w &&
							game.sack.y + game.sack.radius > p.y &&
							game.sack.y - game.sack.radius < p.y + this.h
						) {
							game.state.current = game.state.over;
						}
						// BOTTOM PIPE
						if (
							game.sack.x + game.sack.radius > p.x &&
							game.sack.x - game.sack.radius < p.x + this.w &&
							game.sack.y + game.sack.radius > bottomPipeYPos &&
							game.sack.y - game.sack.radius < bottomPipeYPos + this.h
						) {
							game.state.current = game.state.over;
						}

						// MOVE THE PIPES TO THE LEFT
						p.x -= game.physics.pipeRate;

						// if the pipes go beyond canvas, we delete them from the array
						if (p.x + this.w <= 0) {
							this.position.shift();
							game.score.value += 1;

							self.gameTime.push({
								timestamp: window.performance.now(),
								score: game.score.value,
								difference: 0
							})

							let index = self.gameTime.findIndex(time => time.score === game.score.value);
							
							if (self.gameTime[index - 1]) {
								self.gameTime[index].difference = self.gameTime[index].timestamp - self.gameTime[index - 1].timestamp;
							}
							
							game.score.best = Math.max(game.score.value, game.score.best);
							self.$store.commit('updateBest', game.score.best);
						}
					}
				},

				reset: function() {
					this.position = [];
				},
			};

			self.game = {
				touchCount: this.touchCount,
				canvas: self.game.canvas,
				ctx: self.game.ctx,
				degree: DEGREE,
				fg,
				frames,
				pipes,
				sack,
				score,
				physics: self.physics,
				sprite: self.sprite,
				state: self.state,
			};

			if (self.needsUpdate) {
				self.fly(self.game, true);
				self.needsUpdate = false;
			}

			self.game.canvas.sack.addEventListener(
				'touchstart',
				(e) => {
					handleJump();
					e.stopPropagation();
					e.preventDefault();
				},
				false
			);

			self.game.canvas.sack.addEventListener('click', handleJump);
			window.document.addEventListener('keypress', handleJump);

			function handleJump() {
				if (self.isMenuActive) return;
				jump.action(self.game);
				self.touchCount++;
			}

			function draw() {
				if (self.needsUpdate) {
					self.sprite.src = self.spriteImage;
					self.needsUpdate = false;
				}
				self.game.physics = self.physics;

				for (var ctx in self.game.ctx) {
					self.game.ctx[ctx].clearRect(
						0,
						0,
						self.game.canvas[ctx].width,
						self.game.canvas[ctx].height
					);
				}
				sack.update(self.game);
				fg.update(self.game);
				pipes.update(self.game);

				self.score.current = self.game.score.value;
				self.score.best = self.game.score.best;

				self.game.frames = frames;
				self.game.state = self.state;

				pipes.draw(self.game);
				fg.draw(self.game);
				sack.draw(self.game);
				getReady.draw(self.game);
				self.game.state.current === self.game.state.over
					? (self.isMenuActive = true)
					: (self.isMenuActive = false);
			}

			let stop = false;
			let fpsInterval, now, then, elapsed;

			startAnimating(self.frameRate.gameSpeed);

			function startAnimating(fps) {
				fpsInterval = 1000 / fps;
				then = window.performance.now();
				animate();
			}

			function animate() {
				if (self.debugMode) {
					stats.begin();
				}
				if (stop) {
					return;
				}

				requestAnimationFrame(animate);

				now = window.performance.now();
				elapsed = now - then;

				if (elapsed > parseInt(fpsInterval)) {
					then = now - (elapsed % parseInt(fpsInterval));

					frames++;
					draw();
				}
				if (self.debugMode) {
					stats.end();
				}
			}

			this.resizeCanvas();

			window.addEventListener('resize', this.resizeCanvas());
		},
	};
</script>
